@if (exibirBanner) {
  <span class="environment-badge">
    {{ mensagem }}
  </span>
}
